import React from "react";
import { formatAmount } from "../utils/format";

const NUMERIC_KEYS = ["priceHT", "priceTTC", "price", "settled", "nonSettled", "amount"];

const Table = ({ columns = [], data = [], onRowClick }) => {
  return (
    <div className="overflow-x-auto">
      <table className="w-full border-collapse mt-5 text-left table-auto">
        <thead>
          <tr className="bg-[#6A78F81A] text-[#707070]">
            {columns.map((column, index) => {
              const { key, dataKey, label, flag = true } = column;
              const rowField = dataKey ?? key;
              const isNumericColumn = NUMERIC_KEYS.includes(rowField);
              return (
                <th
                  key={key ?? index}
                  className={`px-4 py-[15px] text-sm font-semibold
                    ${isNumericColumn ? "text-right" : "text-left"}
                    ${rowField === "client" && flag ? "w-[200px] whitespace-normal break-words" : ""}
                    ${index === 0 ? "rounded-tl-[12px] rounded-bl-[12px]" : ""}
                    ${index === columns.length - 1 ? "rounded-tr-[12px] rounded-br-[12px]" : ""}
                  `}
                >
                  {label}
                </th>
              );
            })}
          </tr>
        </thead>

        <tbody>
          {data.length === 0 ? (
            <tr>
              <td colSpan={columns.length} className="text-left px-4 py-3 text-gray-500 border-b border-[#C5C5C5]/25"></td>
            </tr>
          ) : (
            data.map((row, rowIndex) => (
              <tr
                key={rowIndex}
                className="group hover:bg-gray-100 cursor-pointer transition-colors"
                onClick={() => onRowClick && onRowClick(row)}
              >
                {columns.map((column, colIndex) => {
                  const { key, dataKey } = column;
                  const rowField = dataKey ?? key;
                  const rawValue = row[rowField];
                  const isNumericKey = NUMERIC_KEYS.includes(rowField);

                  let rendered = column.render ? column.render(rawValue, row) : null;

                  if (!rendered && isNumericKey) {
                    const n = Number(rawValue);
                    rendered = (
                      <p className="text-[#043F88] font-bold text-sm">
                        {formatAmount(Number.isFinite(n) ? n : 0)}
                      </p>
                    );
                  }

                  const displayContent =
                    isNumericKey && !column.noJustifyEnd
                      ? (
                        <div className="flex items-baseline justify-end gap-1 whitespace-nowrap">
                          {rendered ?? rawValue}
                        </div>
                      )
                      : (rendered ?? rawValue);

                  return (
                    <td
                      key={key ?? colIndex}
                      className={`px-4 py-3 border-b border-[#C5C5C5]/25
    ${NUMERIC_KEYS.includes(rowField)
                          ? "text-[#043F88] font-bold text-sm"
                          : "text-[#38485C] font-semibold break-words"}
    ${colIndex === 0 ? "group-hover:rounded-tl-[12px] group-hover:rounded-bl-[12px]" : ""}
    ${colIndex === columns.length - 1 ? "group-hover:rounded-tr-[12px] group-hover:rounded-br-[12px]" : ""}
  `}
                    >
                      {displayContent}
                    </td>
                  );
                })}
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
};

export default Table;
